export default __webpack_public_path__ + "static/media/qhacksCrown-white.0971fbb9.svg";